import './site-navigation.js';
import '../../../../packages/frontend/components/arti24/arti24.js';
import '../../../../packages/frontend/components/arti24/arti24-stats-link.js';
import '../../../../packages/frontend/components/menu/menu-init.js';
import '../../../../packages/frontend/components/menu/Menu.js';
import './../../../../packages/frontend/components/lit-animated-snow2.js';
import './galery/GaleryViewer.js';
import { initSiteSearch } from '../../../../packages/frontend/components/search/SiteSearch.js';
import './face-painting-calculator.js';

initSiteSearch();
